<template>
    <div>
        <transition name="fade">
            <x-modal 
                v-if="manifestServiceStatus.status===loadingConstant">        
                <x-spinner />
            </x-modal>
        </transition>
        <div v-if="manifestServiceStatus.status===errorConstant">
            <h3>We're sorry, the service for this application is currently down.</h3>
            <h4>Error Message:</h4>
            <p>{{manifestServiceStatus.errorMessage}}</p>
        </div>
        <slot />
    </div>
</template>


<script>
import framework from '../../framework';
/**
 *  The x-form-manifest component.
 *  @module components/x-form-manifest
 */


/**
 * The x-form-manifest
 */
export default {
    name: 'x-form-manifest',
    // provide provides access to context for children
    // eslint-disable-next-line
    provide: function() {
        return {
            applicationInstance: this.applicationInstance,
        };
    },

    props: {
        formName: String,
        manifest: Object,
        parameters: Array,
        applicationInstance: Object,
    },
    mounted() {
        this.setForm();
    },
    computed: {
        manifestServiceStatus() {
            return this.$store.getters.getManifestServiceStatus;
        },
        loadingConstant() {
            return framework.storeConstants.ManifestServiceStatus.Loading;
        },
        errorConstant() {
            return framework.storeConstants.ManifestServiceStatus.Error;
        },
    },
    methods: {
        setForm() {
            if (this.formName) {
                const payload = {
                    formName: this.formName,
                    parameters: this.parameters,
                };
                this.$store.dispatch(
                    framework.storeConstants.ActionTypes.SetFormFromUrl,
                    payload
                );
            } else if (this.manifest) {
                this.$store.dispatch(
                    framework.storeConstants.ActionTypes.SetFormFromManifest,
                    {
                        form: this.manifest,
                    },
                );
            } else {
                throw new Error(`
                        x-form-manifest component must have a 
                        formName prop or a manifest prop.
                    `
                );
            }
        },
    },
};

</script>

<style lang="scss">
    @import
        "../../styles/settings",
        "form-manifest";
</style>




// WEBPACK FOOTER //
// source/components/x-form-manifest/x-form-manifest.vue